<template>
  <div class="editDepartment">
    <!--部门信息-->
    <el-form
      ref="editDepartment"
      label-position="right"
      label-width="100px"
      :model="detail"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.departmentCode')">
            <el-input v-model="detail.createDepartmentCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyStatus')">
            <el-input v-model="detail.currentStatusName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.departmentName')" prop="createDepartmentName">
            <el-input
              v-model="detail.createDepartmentName"
              :maxlength="64"
              clearable
              :placeholder="$t('company.departmentNamePlaceholder')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.receiptClaimMode')" prop="receiptClaimMode">
            <el-select
              filterable
              class="inputWidth"
              v-model="detail.receiptClaimMode"
              :placeholder="$t('company.search.receiptClaimMode')"
              clearable
            >
              <el-option
                v-for="item of receiptClaimModeList"
                style="width: 100%"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyIndex')" prop="sortOrder">
            <el-input-number
              v-model="detail.sortOrder"
              :controls="false"
              class="inputWidth"
              :min="0"
              :max="999"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--上级单位-->
    <div class="department-content" style="margin-bottom: 10px">{{
      this.$t('company.higherDepartmentTitle')
    }}</div>
    <!---可编辑表格-->
    <vxe-table
      border
      size="mini"
      show-overflow
      show-header-overflow
      ref="unitTable"
      class="edit-table"
      :data="unitData"
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="superiorUnitCode"
        :title="$t('company.table.unitName')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <treeselect
            :options="options"
            v-model="scope.row.superiorUnitCode"
            :defaultExpandLevel="Infinity"
            openDirection="auto"
            :clearable="false"
            :maxHeight="200"
            :zIndex="2999"
            :flat="true"
            :append-to-body="true"
            @select="(val) => selectNode(val, scope)"
            @input="(val) => inputChange(val, scope)"
            :placeholder="$t('company.treeselect.searchIndex')"
            :searchPromptText="$t('company.treeselect.searchIndex')"
            :noResultsText="$t('company.treeselect.noData')"
          />
        </template>
        <template v-slot="{ row }">{{ row.superiorUnit }}</template>
      </vxe-table-column>
    </vxe-table>
    <!--控制范围-->
    <div class="department-content control-content">{{ this.$t('company.controlTitle') }}</div>
    <!--新增/删除按钮-->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="deleteEvent()"
          >{{ $t('xTable.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      size="mini"
      show-overflow
      show-header-overflow
      ref="xTable"
      class="edit-table"
      :data="tableData"
      :edit-rules="validControlRules"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
      @cell-click="cellClick"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="controlAreaCode"
        :title="$t('company.table.controlareaName')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select
            style="width: 100px"
            clearable
            filterable
            remote
            :remote-method="remoteMethod"
            v-model="scope.row.controlAreaCode"
            :placeholder="$t('company.departmentPlaceholder')"
            @change="(val) => changeControl(val, scope)"
          >
            <el-option
              v-for="item in controlAreaList"
              :key="item.controlAreaCode"
              :label="item.controlAreaName + '(' + item.controlAreaCode + ')'"
              :value="item.controlAreaCode"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          row.controlAreaName || getSelectLabel(row.controlAreaCode)
        }}</template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  // import SiruiTable from '@/components/SiruiTable';
  import { isEqual } from '@/common/js/util';
  import XEUtils from 'xe-utils';
  export default {
    name: 'editDepartment',
    components: {
      // SiruiTable,
    },
    data() {
      return {
        options: [],
        node: {},
        allControlAreaList: [],
        controlAreaList: [],
      };
    },
    props: {
      receiptClaimModeList: {
        type: Array,
        default: () => [],
      },
      detail: {
        type: Object,
        default: () => {},
      },
      unitData: {
        type: Array,
        default: () => [],
      },
      tableData: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value != null && value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          createDepartmentName: [
            {
              required: true,
              message: this.$t('company.departmentNameNotEmpty'),
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          receiptClaimMode: [
            {
              required: true,
              message: this.$t('company.search.receiptClaimMode'),
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
      validRules() {
        return {
          superiorUnitCode: [{ required: true, message: this.$t('company.UnitNotEmpty') }],
        };
      },
      validControlRules() {
        return {
          controlAreaCode: [{ required: true, message: this.$t('company.controlAreaNotEmpty') }],
        };
      },
    },
    methods: {
      initData() {
        if (this.$refs['editDepartment']) {
          this.$refs['editDepartment'].resetFields();
        }
        this.options = [];
        this.node = {};
        this.controlAreaList = [];
        //初始化上级单位
        this.initDepartment();
        //初始化控制范围
        this.initControlArea();
      },
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
          treeFlag: 1,
        };
        this.$axios.post(API.LIST_COMPANY_API, params).then((res) => {
          if (0 == res.data.code) {
            this.options = res.data.data;
            this.getSelectedNode(this.options, this.options);
            this.inputFocus(this.unitData[0]);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      initControlArea() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
        this.$axios.post(API.GET_CONTROL_AREA_LIST, params).then((res) => {
          if (0 == res.data.code) {
            this.allControlAreaList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //模糊搜索
      remoteMethod(query) {
        if (query != '') {
          const params = {
            tenantCode: this.userInfo.userInfo.tenantCode,
            controlAreaName: query ? query : null,
          };
          this.$axios.post(API.GET_CONTROL_AREA_LIST, params).then((res) => {
            if (0 == res.data.code) {
              this.controlAreaList = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.controlAreaList = [];
        }
      },
      //点击单行，默认赋值全部
      cellClick() {
        this.controlAreaList = this.allControlAreaList;
      },
      //根据code匹配出name
      getSelectLabel(value, valueProp = 'controlAreaCode', labelField = 'controlAreaName') {
        let item = XEUtils.find(this.allControlAreaList, (item) => item[valueProp] === value);
        return item ? item[labelField] + '(' + value + ')' : null;
      },
      //选中节点
      selectNode(node, scope) {
        this.node = node;
        scope.row.superiorUnit =
          node.attributes.createCompanyName || node.attributes.createDepartmentName;
        this.$refs.unitTable.updateStatus(scope);
      },
      //清空之后
      inputChange(value, scope) {
        if (!value) {
          scope.row.superiorUnit = null;
          scope.row.superiorUnitCode = null;
          this.$refs.unitTable.updateStatus(scope);
        }
      },
      inputFocus(scope) {
        let arr = this.options;
        let n = scope.superiorUnitCode.indexOf('C');
        const setNames = function (datas) {
          for (let i in datas) {
            datas[i].isDisabled = true;
            if (datas[i].children) {
              setNames(datas[i].children);
            }
          }
        };
        const setName = function (datas) {
          for (let i in datas) {
            if (n >= 0) {
              if (datas[i].id == scope.superiorUnitCode) {
                setNames(datas[i].children);
              } else {
                setName(datas[i].children);
              }
            } else {
              if (datas[i].treeCode == scope.superiorUnitCode) {
                setNames(datas[i].children);
              } else {
                setName(datas[i].children);
              }
            }
          }
        };
        setName(arr);
        this.options = arr;
      },
      //新增一行
      insertEvent() {
        const tableList = this.$refs.xTable.getTableData().fullData;
        if (tableList.length == 0) {
          this.$refs.xTable.validate().then(() => {
            this.controlAreaList = [];
            const record = {
              controlAreaCode: null,
              controlAreaName: null,
            };
            this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
          });
          // this.$refs.xTable.validate(valid => {
          //   if (valid) {
          //     this.controlAreaList = [];
          //     const record = {
          //       controlAreaCode: null,
          //       controlAreaName: null
          //     };
          //     this.$refs.xTable
          //       .insert(record)
          //       .then(({ row }) => this.$refs.xTable.setActiveRow(row));
          //   }
          // });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.onlyOneChange'),
            type: 'error',
          });
        }
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //更改下拉框的值，默认更改整个row
      changeControl(value, scope) {
        let item = XEUtils.find(this.allControlAreaList, (item) => item.controlAreaCode === value);
        scope.row.controlAreaName = item.controlAreaName;
        this.$refs.xTable.updateStatus(scope);
      },
      addSure(load) {
        // let xTableValidFlag = true;
        // let uTableValidFlag = true;
        let status = false;
        // 0.校验上级单位表格
        this.$refs.unitTable.validate().then(() => {
          this.$refs.xTable.validate().then(() => {
            const tableList = this.$refs.xTable.getTableData().fullData;
            //2.判断是否有重复的数据
            if (tableList.length > 1) {
              let start = 1;
              for (let n = 0; n < tableList.length; n++) {
                if (status) {
                  break;
                }
                for (start; start < tableList.length; start++) {
                  if (n != start) {
                    status = isEqual(tableList[n], tableList[start], 'controlAreaCode');
                  }
                }
                start = n;
              }
            }
            if (status) {
              this.$message({
                showClose: true,
                message: this.$t('company.controlAreaSameData'),
                type: 'error',
              });
              return;
            }
            //4.校验form
            this.$refs['editDepartment'].validate((valid) => {
              if (valid && !load) {
                this.$emit('setLoading', { loading: true });
                if (JSON.stringify(this.node) != '{}') {
                  this.detail.parentDepartmentCode =
                    this.node.type == 'company' ? 0 : this.node.attributes.createDepartmentCode;
                  this.detail.belongCompanyCode =
                    this.node.type == 'company'
                      ? this.node.attributes.createCompanyCode
                      : this.node.attributes.belongCompanyCode;
                  this.detail.parentTreeCode =
                    this.node.type == 'company' ? 0 : this.node.attributes.treeCode;
                }
                this.detail.controlAreaStr =
                  tableList.length == 0 ? null : JSON.stringify(tableList);
                this.$axios.post(API.UPDATE_DEPARTMENT_API, this.detail).then((res) => {
                  this.$emit('setLoading', { loading: false, edit: false });
                  if (0 != res.data.code) {
                    this.$alert(res.data.msg);
                  } else {
                    this.$emit('getData');
                    this.$message({
                      showClose: true,
                      message: res.data.msg || this.$t('message.success'),
                      type: 'success',
                    });
                  }
                });
              } else {
                return false;
              }
            });
          });
        });

        // this.$refs.unitTable.validate(uTableValid => {
        //   uTableValidFlag = uTableValid;
        //   if (uTableValid) {
        //     //1.校验控制范围表格
        //     this.$refs.xTable.validate(xTableValid => {
        //       xTableValidFlag = xTableValid;
        //       if (xTableValid) {
        //         const tableList = this.$refs.xTable.getTableData().fullData;
        //         //2.判断是否有重复的数据
        //         if (tableList.length > 1) {
        //           let start = 1;
        //           for (let n = 0; n < tableList.length; n++) {
        //             if (status) {
        //               break;
        //             }
        //             for (start; start < tableList.length; start++) {
        //               if (n != start) {
        //                 status = isEqual(
        //                   tableList[n],
        //                   tableList[start],
        //                   "controlAreaCode"
        //                 );
        //               }
        //             }
        //             start = n;
        //           }
        //         }
        //         if (status) {
        //           this.$message({
        //             showClose: true,
        //             message: this.$t("company.controlAreaSameData"),
        //             type: "error"
        //           });
        //           return;
        //         }
        //         //4.校验form
        //         this.$refs["editDepartment"].validate(valid => {
        //           if (valid && !load) {
        //             this.$emit("setLoading", { loading: true });
        //             if (JSON.stringify(this.node) != "{}") {
        //               this.detail.parentDepartmentCode =
        //                 this.node.type == "company"
        //                   ? 0
        //                   : this.node.attributes.createDepartmentCode;
        //               this.detail.belongCompanyCode =
        //                 this.node.type == "company"
        //                   ? this.node.attributes.createCompanyCode
        //                   : this.node.attributes.belongCompanyCode;
        //               this.detail.parentTreeCode =
        //                 this.node.type == "company"
        //                   ? 0
        //                   : this.node.attributes.treeCode;
        //             }
        //             this.detail.controlAreaStr =
        //               tableList.length == 0 ? null : JSON.stringify(tableList);
        //             this.$axios
        //               .post(API.UPDATE_DEPARTMENT_API, this.detail)
        //               .then(res => {
        //                 this.$emit("setLoading", { loading: false, edit: false });
        //                 if (0 != res.data.code) {
        //                   this.$alert(res.data.msg);
        //                 } else {
        //                   this.$emit("getData");
        //                   this.$message({
        //                     showClose: true,
        //                     message: res.data.msg || this.$t("message.success"),
        //                     type: "success"
        //                   });
        //                 }
        //               });
        //           } else {
        //             return false;
        //           }
        //         });
        //       }
        //     });
        //   }
        // });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
  .control-content {
    margin-top: 15px;
    margin-bottom: 10px;
  }
  ::v-deep
    .vue-treeselect__list
    > .vue-treeselect__list-item
    > .vue-treeselect__option--disabled
    > .vue-treeselect__label-container
    > .vue-treeselect__label {
    // .vue-treeselect__label-container{
    // .vue-treeselect__label{
    color: #ccc !important;
    background: #000 !important;
    cursor: no-drop !important;
    // }
    // }
  }
</style>
